// extracted by mini-css-extract-plugin
export default {"PageHolder":"OrderCondition_PageHolder__zmK7p","tabHolder":"OrderCondition_tabHolder__00aBt","onFocus":"OrderCondition_onFocus__rkeXz","cursor":"OrderCondition_cursor__jdSaY"};